<template>
<div>
    <button type="button" :class="cssclass" @click="downLoadCsv" :disabled="isDisabled">{{title}}</button>
</div>
   
</template>

<script>
/* 
* Import librares
*/
import common from 'assets/js/common';
import axios from "assets/js/request";
import EventBus from "assets/js/eventBus";

export default {
    name: "downloadFile",
    props:{

        title:{

            type: String, // title for button 
            default: 'Download',
        },
        url:{
            type: String, // url request download file
            default: "",
            required: true
        },
        method:{
            type: String, // method for request download file
            default: "POST",
        },
        responseType:{
            type: String, // response type
            default: 'blob', // important
        },
        data: {
            type: Object, // data for request download file
            required: true
        },
        isDisabled:{
            type: Boolean,
            default: false
        },
        dataRefer:{
            type: Object
        },
        cssclass:{
            type: String,
            default: 'btn btn-secondary btn-sm'
        }
    },
    data: function(){
        return{
        }
    },
    methods:{
        /*
        * Function download file
        */
        downLoadCsv: function() {
            var _this = this;
            var dataReqDownload = {};
            dataReqDownload = _this.data;
            // check download flg
            if(_this.dataRefer != undefined){
                if(!_this.isEmpty(_this.dataRefer))
                    dataReqDownload = Object.assign({}, dataReqDownload, _this.dataRefer);
            }
            EventBus.$emit('is-loading', true);
            axios({url: _this.url, method: _this.method, responseType: _this.responseType, data: dataReqDownload}).then(function(response){
                var fileName = "";
                var disposition = response.headers['content-disposition'];
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) { 
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }

                // Internet Explorer 6-11
                var isIE = /*@cc_on!@*/false || !!document.documentMode;

                if(isIE == true)
                {
                    window.navigator.msSaveBlob(new Blob([response.data]),fileName);
                }else{
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                EventBus.$emit('is-loading', false);
            }).catch(function(error){
                EventBus.$emit('is-loading', false);
                var reader = new FileReader();
                reader.onload = function() {
                    if(error != null && error != undefined){
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var readerResult=JSON.parse(reader.result);
                                error.response.data.errorList=readerResult.errorList;
                                //common.excuteValidation(error);
                                common.errorAPI(error);
                            }else{
                                common.errorAPI(reader.result);
                            }
                        }
                    }
                   //common.errorAPI(error);
                }
                reader.readAsText(error.response.data);
            });
        },
        /*
        * Check obj is empty
        */
        isEmpty: function(obj) {
            for(var key in obj) {
                if(obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        }
    }
}
</script>

